import { Outlet } from 'react-router-dom'
import { PatternEditContainer } from './__styled'
import { AxiosProvider } from '@/context/Axios'

/**
 * Pattern Layout - Now supports guest access
 * No auth requirement here, pattern page handles guest mode internally
 */
export default function PatternLayout() {
  return (
    <AxiosProvider>
      <PatternEditContainer>
        <Outlet />
      </PatternEditContainer>
    </AxiosProvider>
  )
}
